import { $fetch } from '@/boot/fetch'

const endpoint = '/returns/sessions'

export default {
  /**
   * @description start a return session
   * @function start
   * @returns {Promise} - { returnSession: { id }}
   */
  start() {
    return $fetch.peg(endpoint, {
      method: 'POST',
    })
  },
}
